/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Lush_Hen_RideInputs */

const en_warm_lush_hen_ride = /** @type {(inputs: Warm_Lush_Hen_RideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

const de_warm_lush_hen_ride = /** @type {(inputs: Warm_Lush_Hen_RideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiter`)
};

/**
* | output |
* | --- |
* | "Next" |
*
* @param {Warm_Lush_Hen_RideInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_lush_hen_ride = /** @type {((inputs?: Warm_Lush_Hen_RideInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Lush_Hen_RideInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_lush_hen_ride(inputs)
	return de_warm_lush_hen_ride(inputs)
});